import * as React from 'react';

import WithGlobalNavAndStyleGuide from 'bundles/admin-dashboard/components/WithGlobalNavAndStyleGuide';
import WithGlobalSideNavAndStyleGuide from 'bundles/admin-dashboard/components/WithGlobalSideNavAndStyleGuide';
import { useIsAdminSideNavActive } from 'bundles/enterprise-admin-hooks/hooks/useFeatures';

type Props = {
  children: JSX.Element;
};

const WithConditionalGlobalNav = ({ children, ...props }: Props) => {
  const sideNavOn = useIsAdminSideNavActive();

  if (sideNavOn) {
    return <WithGlobalSideNavAndStyleGuide {...props}>{children}</WithGlobalSideNavAndStyleGuide>;
  }

  return <WithGlobalNavAndStyleGuide {...props}>{children}</WithGlobalNavAndStyleGuide>;
};

export default WithConditionalGlobalNav;
